"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEthersError = exports.TransactionErrors = void 0;
const ethers_1 = require("ethers");
var TransactionErrors;
(function (TransactionErrors) {
    TransactionErrors[TransactionErrors["REJECTED"] = 0] = "REJECTED";
    TransactionErrors[TransactionErrors["REPLACED"] = 1] = "REPLACED";
    TransactionErrors[TransactionErrors["CANCELLED"] = 2] = "CANCELLED";
    TransactionErrors[TransactionErrors["EXCEPTION"] = 3] = "EXCEPTION";
    TransactionErrors[TransactionErrors["LEDGER_ERROR"] = 4] = "LEDGER_ERROR";
    TransactionErrors[TransactionErrors["INSUFFICIENT_FUNDS"] = 5] = "INSUFFICIENT_FUNDS";
    TransactionErrors[TransactionErrors["PENDING"] = 6] = "PENDING";
    TransactionErrors[TransactionErrors["OTHER"] = 7] = "OTHER";
})(TransactionErrors || (exports.TransactionErrors = TransactionErrors = {}));
/**
 * @dev Pass in the EthersError returned by things like waitForTransaction()
 * in ethers and this will return a more nuanced enum for you to switch through.
 *
 * When paired with isError() you can infer the EthersError subtypes and be
 * fully typed in your error handlers.
 *
 * @param error EthersError
 * @returns TransactionErrors
 *
 * @ref https://docs.ethers.org/v6/api/utils/errors/#ErrorCode
 * @ref https://docs.ethers.org/v6/api/utils/errors/#isError
 */
const parseEthersError = (error) => {
    if ((0, ethers_1.isError)(error, 'ACTION_REJECTED')) {
        return TransactionErrors.REJECTED;
    }
    if ((0, ethers_1.isError)(error, 'TRANSACTION_REPLACED')) {
        return TransactionErrors.REPLACED;
    }
    if ((0, ethers_1.isError)(error, 'INSUFFICIENT_FUNDS')) {
        return TransactionErrors.INSUFFICIENT_FUNDS;
    }
    if (error.message.includes('Ledger')) {
        return TransactionErrors.LEDGER_ERROR;
    }
    if (error.message.includes('UserRefusedOnDevice')) {
        return TransactionErrors.REJECTED;
    }
    if (parseInt(error.code) === -32002 && error.message && error.message.includes('pending')) {
        console.warn('Transaction pending in wallet error');
        return TransactionErrors.PENDING;
    }
    if (error.message.includes('cancelled') && !(error === null || error === void 0 ? void 0 : error.cancelled)) {
        return TransactionErrors.REJECTED;
    }
    if ((0, ethers_1.isError)(error, 'CANCELLED')) {
        return TransactionErrors.CANCELLED;
    }
    if ((0, ethers_1.isError)(error, 'CALL_EXCEPTION')) {
        return TransactionErrors.EXCEPTION;
    }
    if ((0, ethers_1.isError)(error, 'UNKNOWN_ERROR')) {
        return TransactionErrors.OTHER;
    }
    return TransactionErrors.OTHER;
};
exports.parseEthersError = parseEthersError;
//# sourceMappingURL=web3TransactionError.js.map